module.exports = __webpack_public_path__ + "img/yuyin.b96e330a.png";